import { Injectable } from '@angular/core';
import { UserAccessGroup } from '@app/shared/enums';
import { IAuthenticationService, IUserClaims, ShellService } from '@mynexus/mfe-core';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService implements IAuthenticationService {
  constructor(private shellService: ShellService) {}

  // todo: Update the IAuthentication interface to include this method and remove the 'token' property.
  getToken(): Promise<string> {
    return this.shellService.authenticationService.getToken();
  }

  get userClaims(): IUserClaims | null {
    return this.shellService.authenticationService.userClaims;
  }

  get userEmail(): string | null {
    return this.shellService.authenticationService.userEmail;
  }

  get userGroups(): string[] {
    return this.shellService.authenticationService.userGroups;
  }

  get userName(): string {
    return this.shellService.authenticationService.userName;
  }

  get userPermissions(): string[] {
    return this.shellService.authenticationService.userPermissions;
  }

  get isPACOperations(): boolean {
    return this.hasGroup('PACOperations');
  }

  get isPACCommercialOperations(): boolean {
    return this.hasGroup('PACCommercialOperations');
  }

  get isExternalUser(): boolean {
    if (this.userClaims) {
      return this.userClaims.extension_isExternal;
    }

    return false;
  }

  private hasGroup(groupName: UserAccessGroup, skipExternal?: boolean): boolean {
    const claims = this.userClaims;

    if (claims && claims.groups && (skipExternal || !claims.extension_isExternal)) {
      return claims.groups.includes(groupName);
    }

    return false;
  }
}
